export default __webpack_public_path__ + "static/media/carousel_1_300.1559c06c.webp";